/* Posts newsletter sign-ups to the Salt CDP backend, then lets the native Shopify submit proceed.
   The Shopify subscription never fails because the CDP did (mirrors INV-SIGNUP-04 on the client). */
(function () {
  var config = document.getElementById('cdp-config');
  if (!config) return;
  var API = (config.getAttribute('data-api-base') || '').replace(/\/$/, '');
  if (!API) return;

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function fetchToken(state) {
    return fetch(API + '/api/v1/newsletter/token')
      .then(function (r) { return r.json(); })
      .then(function (j) { state.token = j.token || null; })
      .catch(function () { state.token = null; });
  }

  var DOB_MIN = '1900-01-01';

  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }

  // A date input without max accepts a six-digit year, and browsers that fall back to a text
  // field accept anything; only a real calendar day between 1900 and today is a date of birth.
  function validBirthDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!m) return false;
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    if (d.getUTCFullYear() !== +m[1] || d.getUTCMonth() !== +m[2] - 1 || d.getUTCDate() !== +m[3]) return false;
    return value >= DOB_MIN && value <= today();
  }

  function showError(form, fields, fieldErrors) {
    var out = form.querySelector('[data-cdp-error]');
    if (!out) return;
    var field = fieldErrors ? Object.keys(fieldErrors)[0] : null;
    var key = field && fieldErrors[field] === 'required' ? 'required' : 'invalid';
    out.textContent = fields.getAttribute('data-cdp-msg-' + key) || 'Please check the highlighted field.';
    out.hidden = false;
    var input = field ? form.querySelector('[name="' + field + '"]') : null;
    if (input && input.focus) input.focus();
  }

  function setup(form) {
    var fields = form.querySelector('[data-cdp-fields]');
    if (!fields || form.getAttribute('data-cdp-ready')) return;
    form.setAttribute('data-cdp-ready', '1');
    var state = { token: null, passthrough: false };

    // With max set the browser's own picker stops at a four-digit year and at today.
    var dob = form.querySelector('[name="dateofbirth"]');
    if (dob) { dob.min = DOB_MIN; dob.max = today(); }

    // Fetch the token when the form is actually shown (the popup opens late), so the 3 s
    // minimum token age has elapsed by the time a human can submit.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fetchToken(state); }
      });
      io.observe(form);
    } else {
      fetchToken(state);
    }

    form.addEventListener('submit', function (e) {
      if (state.passthrough) return; // second pass: native Shopify submit
      e.preventDefault();
      var f = new FormData(form);
      var out = form.querySelector('[data-cdp-error]');
      if (out) out.hidden = true;
      if (!validBirthDate(f.get('dateofbirth'))) {
        showError(form, fields, { dateofbirth: f.get('dateofbirth') ? 'invalid' : 'required' });
        return;
      }
      // One checkbox is both the TC/PP record and the marketing opt-in.
      var consent = f.get('tcpp') === 'true' || f.get('tcpp') === 'on';
      var body = {
        token: state.token,
        email: f.get('contact[email]'),
        firstname: f.get('firstname') || null,
        lastname: f.get('lastname') || null,
        dateofbirth: f.get('dateofbirth') || null,
        zipcode: f.get('zipcode') || null,
        province: f.get('province') || null,
        tcpp: consent,
        marketing: consent,
        td_client_id: cookie('_td'),
        page_url: location.href,
        turnstile_token: f.get('cf-turnstile-response') || null,
        hp: f.get('hp') || ''
      };
      var controller = 'AbortController' in window ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 5000) : null;

      function native() {
        state.passthrough = true;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      }

      fetch(API + '/api/v1/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller ? controller.signal : undefined
      })
        .then(function (r) {
          if (r.status === 400) {
            return r.json().then(function (j) { showError(form, fields, j.fieldErrors); });
          }
          if (r.status === 403) {
            // Token too young / replayed: refresh for the next attempt, still subscribe natively.
            fetchToken(state);
          }
          native();
        })
        .catch(function () { native(); })
        .finally(function () { if (timer) clearTimeout(timer); });
    });
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('form'), setup); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
